import React from "react";

/**
 * Drive folder row or grid tile. Comments cell is a placeholder (`"-"`).
 *
 * @param {Object} props Component props.
 * @param {string} props.name Display name.
 * @param {React.ReactNode} props.icon Folder icon.
 * @param {Function} props.onClick Row/tile click handler.
 * @param {boolean} props.isGridView Grid vs list layout.
 * @param {boolean} [props.comments] When true, show the comments column cell.
 * @returns {JSX.Element}
 */
const Folder = ({ name, icon, onClick, isGridView, comments }) => {
  return isGridView ? (
    <div
      className="bg-white border rounded-lg p-4 shadow-sm hover:bg-gray-100 hover:cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center justify-center mb-4 text-4xl">
        {icon}
      </div>
      <div className="text-center text-sm font-semibold truncate">
        {name || "-"}
      </div>
    </div>
  ) : (
    <div
      className={`grid ${comments ? "grid-cols-3" : "grid-cols-1"} gap-4 p-1 border-b hover:bg-gray-200 hover:cursor-pointer`}
      onClick={onClick}
    >
      <div className={`${comments ? "col-span-2" : "col-span-1"} flex items-center space-x-2`}>
        {icon}
        <span className="text-emerald-950 font-semibold truncate">
          {name || "-"}
        </span>
      </div>
      {comments && (
        <div className="text-gray-600 text-sm truncate col-span-1">
          {"-"} {/* Placeholder for comments */}
        </div>
      )}
    </div>
  );
};

export default Folder;
